// extracted by mini-css-extract-plugin
export default {"label":"ModMessageForm-label-2fcd135416db107fe73252e2a31629ce","required":"ModMessageForm-required-9e1ba9e8d471389eca21830a2cd3925f"};